// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"746":"309ef9aa","883":"ba93197e"}[chunkId] + ".chunk.js";
};